// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
.company-switch {
  border: 1px solid #1161be;
  font-size: 27px;
  color: #1ba953;
  cursor: pointer;
  width: 37px;
  height: 37px;
  text-align: center;
  vertical-align: middle;
  line-height: 37px;
}

.company-switch-no-icon {
  box-shadow: 0 2px 4px 0 #a0a0a0;
  font-size: 27px;
  color: #1161be;
  cursor: pointer;
  width: 37px;
  height: 37px;
  text-align: center;
  vertical-align: middle;
  line-height: 39px;
}

.company-name {
  padding: 0 7px;
  font-size: 10px;
  color: #8291ae;
}

.company-text {
  font-family: NotoSans;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1161be;
  padding-left: 8px;
  padding-top: 20px;
}

.company-image {
  padding-left: 5px;
  padding-top: 11px;
}

.company-box {
  display: flex;
  height: 60px;
  cursor: pointer;
}

.company-box:hover {
  background: #e1eefe;
}

.wrapper {
  overflow: visible;
}
.wrapper .nav-bar ul {
  list-style: none;
  padding-left: 10px;
  margin: 0;
  position: relative;
}
.wrapper .nav-bar ul li {
  vertical-align: middle;
  display: inline-block;
  padding: 13px 20px;
  border: 0px;
  border-left-width: 3px;
  border-style: solid;
}
.wrapper .nav-bar .dropdown-container {
  display: inline-block;
  position: relative;
}
.wrapper .nav-bar .dropdown-container ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.wrapper .nav-bar .dropdown-container ::-webkit-scrollbar-track {
  webkit-box-shadow: inset 0 0 6px #f7f8fc;
  border-radius: 10px;
  background: #f7f8fc;
}
.wrapper .nav-bar .dropdown-container ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #1161be;
  -webkit-box-shadow: none;
}
.wrapper .nav-bar .dropdown-container ::-webkit-scrollbar-thumb:window-inactive {
  background: #1161be;
}
.wrapper .nav-bar .dropdown-container .dropdown {
  position: relative;
  cursor: pointer;
  z-index: 2;
}
.wrapper .nav-bar .dropdown-container .dropdown-menu {
  position: absolute;
  display: block;
  z-index: 1;
  border: 0;
  border-radius: 0;
  left: -6px;
  top: 50px;
  min-height: 10px;
  min-width: 10px;
  width: 270px;
}
.wrapper .nav-bar .dropdown-container .dropdown-menu .dropdown-body {
  max-height: 80vh;
  background: #fefeff;
  overflow-y: auto;
  overflow-x: auto;
  box-shadow: 0 4px 4px 0 #bbb5b5;
}
.wrapper .nav-bar .dropdown-container .count {
  position: absolute;
  top: -6px;
  right: -1px;
  height: 15px;
  width: 15px;
  overflow: hidden;
  background: #1ba953;
  color: #fff;
  text-align: center;
  border-radius: 100%;
  font-size: 9px;
  font-weight: bold;
  line-height: 15px;
}
.wrapper .nav-bar .messages {
  margin-left: 10px;
}
.wrapper .nav-bar .user {
  background: #1161be;
  border-left: 0px;
  position: absolute;
  right: 0;
  top: -1px;
}

::-webkit-scrollbar {
  width: 3px;
}

::-webkit-scrollbar-track {
  webkit-box-shadow: inset 0 0 6px #f7f8fc;
  border-radius: 10px;
  background: #f7f8fc;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #1161be;
  -webkit-box-shadow: none;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #1161be;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/app/layout/header/header.component.scss"],"names":[],"mappings":"AACA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AC7LA;EACE,yBAAA;EACA,eAAA;EACA,cDeU;ECdV,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AAWF;;AARA;EACE,+BAAA;EACA,eAAA;EACA,cDRS;ECST,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AAWF;;AARA;EACE,cAAA;EACA,eAAA;EACA,cDhBS;AC2BX;;AAPA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cDhCS;ECiCT,iBAAA;EACA,iBAAA;AAUF;;AAPA;EACE,iBAAA;EACA,iBAAA;AAUF;;AAPA;EACE,aAAA;EACA,YAAA;EACA,eAAA;AAUF;;AAPA;EACE,mBD/Ce;ACyDjB;;AAPA;EACE,iBAAA;AAUF;AAPI;EACE,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AASN;AAPM;EACE,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;AASR;AALI;EACE,qBAAA;EACA,kBAAA;AAON;AALM;EACE,UAAA;EACA,WAAA;AAOR;AAJM;EACE,wCAAA;EAEA,mBAAA;EACA,mBDhFS;ACsFjB;AAHM;EAEE,mBAAA;EACA,mBD3FG;EC4FH,wBAAA;AAKR;AAFM;EACE,mBDhGG;ACoGX;AADM;EACE,kBAAA;EACA,eAAA;EACA,UAAA;AAGR;AAAM;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EAEA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EAEA,YAAA;AAAR;AAEQ;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;AAAV;AAKM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBD7HI;EC8HJ,WD/II;ECgJJ,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAHR;AAWI;EACE,iBAAA;AATN;AAYI;EACE,mBD3JK;EC4JL,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAVN;;AAeA;EACE,UAAA;AAZF;;AAeA;EACE,wCAAA;EAEA,mBAAA;EACA,mBDvKe;AC2JjB;;AAeA;EAEE,mBAAA;EACA,mBDlLS;ECmLT,wBAAA;AAZF;;AAeA;EACE,mBDvLS;AC2KX","sourcesContent":["\n/***************************************************************\n ******************** FMS custom variables *********************\n **************************************************************/\n$fms-white: #fff;\n$fms-black: #000;\n\n$fms-gray-text: #252525;\n\n//primary\n$fms-blue: #1161be;\n//$fms-blue-dark: #00264f;\n$fms-blue-light: #e1eefe;\n$fms-gray-dark: #252525;\n$fms-gray: #8291ae;\n$fms-gray-light: #f7f8fc;\n\n// $fms-gray-tone: #f0f3f2;\n// $fms-gray-bg: #f9fbfc;\n// $fms-gray-border: #e9eef0;\n// $fms-link-color: #248cfc;\n$fms-green: #1ba953;\n$fms-green-light: #daf8e6;\n\n$fms-yellow: #fbcd1e;\n$fms-yellow-light: #fff4cb;\n//secondary\n\n\n$fms-blue-secondary: #bee7ff;\n\n$fms-purple: #ebe8fc;\n$fms-orange: #ff612c;\n$fms-red: #f64540;\n$fms-pink: #ff5b84;\n\n\n\n$fms-error: $fms-red;\n$fms-pending: $fms-yellow;\n$fms-positive: $fms-green;\n$fms-padding-x: 1.375rem;\n// $fms-grid-border-color: $fms-gray-light;\n// $fms-grid-color: $fms-gray-dark;\n// $fms-grid-header-background-color: $fms-white; //$fms-gray-light;\n// $fms-grid-row-even-background-color: $fms-white;\n// $fms-grid-row-hover-background-color:#E1F1F7;\n// $fms-grid-row-padding-y: 1.4rem; //original 1.5rem\n// $fms-checkbox-size: 1.25rem;\n// $fms-checkbox-size-sm: .875rem;\n// $fms-checkbox-size-lg: 1.875rem;\n$fms-font-family: 'Noto Sans';\n// $fms-font-family-medium: \"Graphik Medium\";\n// $fms-font-family-bold: \"Graphik Bold'\";\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables before ****************\n **************************************************************/\n\n\n$btn-disabled-opacity: .35;\n$input-btn-focus-box-shadow: none;\n$input-btn-active-box-shadow: none;\n$btn-box-shadow: none;\n$btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n\n$body-bg: $fms-gray-light;\n$body-color: $fms-gray-dark;\n\n\n\n@import 'node_modules/bootstrap/scss/functions';\n@import 'node_modules/bootstrap/scss/variables';\n\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables after ****************\n **************************************************************/\n\n$grid-breakpoints: (xs: 0,\nsm: 1px,\nmd: 2px,\nlg: 3px,\nxl: 100px);\n\n\n//Fonts\n$font-family-sans-serif: $fms-font-family;\n$font-family-base: $font-family-sans-serif;\n\n\n$link-color: $fms-blue;\n//$link-color-active: $fms-blue;\n\n$theme-colors: (\"primary\": $fms-blue,\n\"warning\": $fms-pending,\n\"danger\": $fms-red,\n\"info\": $fms-blue,\n\"success\": $fms-green);\n\n\n\n//Headings\n//$headings-font-family: $fms-font-family-medium;\n$headings-color: $fms-gray-dark;\n$headings-font-weight: bold;\n// $headings-margin-bottom: 1.5rem;\n// $h1-font-size: 2.44125rem;\n// $h2-font-size: 1.953125rem;\n// $h3-font-size: 1.563125rem;\n// $h4-font-size: 1.25rem;\n// $h1-line-height: 3.125rem; //fms var\n// $h2-line-height: 2.625rem; //fms var\n// $h3-line-height: 1.875rem; //fms var\n// $h4-line-height: 1.5rem; //fms var\n\n//Nav\n$navbar-padding-y: $spacer *  0.75;\n$navbar-padding-x: $spacer * 2;\n\n$navbar-light-color: $fms-gray-text;\n$navbar-light-hover-color: $link-hover-color;\n$navbar-light-active-color: $link-hover-color;\n$navbar-light-disabled-color: rgba($fms-gray-text, .3);\n\n\n//Card\n\n$card-cap-bg: $fms-white;\n$card-bg: $fms-gray-light;\n\n//Table\n\n$table-bg: $fms-white;\n$table-accent-bg: $fms-gray-light;\n$table-hover-bg: rgba($component-active-bg, .2);\n$table-active-bg:  rgba($component-active-bg, .3);\n\n//Small text\n// $small-font-size: 0.8125rem;\n// $small-line-height: 1.125rem; //bac var\n\n// Buttons + Forms\n\n//\n// $btn-padding-y: .575rem;\n// $btn-padding-y-lg: $btn-padding-y;\n// $btn-padding-x-sm: 1.25rem;\n// $btn-padding-y-sm: .40625rem;\n// $btn-border-radius: .3rem;\n// $btn-border-radius-lg: $btn-border-radius;\n// $btn-border-radius-sm: $btn-border-radius;\n// $input-color: $fms-gray-dark;\n// $input-border-radius: 0;\n// $input-border-radius-lg: $input-border-radius;\n// $input-border-radius-sm: $input-border-radius;\n// $input-border-color: $fms-gray;\n// $input-border-width: 0.0625rem; //1px\n\n// $input-padding-x: .75rem;\n// $input-padding-y: .938rem;\n// $form-group-margin-bottom: 2rem;\n\n//Paragrahs\n//$paragraph-margin-bottom: .5rem;\n\n//Cards\n// $card-border-color: $fms-gray-border;\n// $card-spacer-x: $fms-padding-x;\n\n\n/* Alerts */\n// $alert-padding-y: .5rem;\n// $alert-padding-x: .625rem;\n\n/* Badges */\n\n// $badge-padding-x: 1rem;\n// $badge-padding-y: .2rem;\n// $badge-border-radius: .25rem;\n\n/* Modals */\n// $modal-lg: 684px;\n// $modal-content-border-radius: 0;\n// $modal-backdrop-bg: $fms-blue-dark;\n// $modal-backdrop-opacity: .8;\n\n/* Dropdowns */\n//$dropdown-item-padding-x: .9375rem\n","@import \"../../../styles/variables\";\n\n\n.company-switch {\n  border: 1px solid $fms-blue;\n  font-size: 27px;\n  color: $fms-green;\n  cursor: pointer;\n  width: 37px;\n  height: 37px;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 37px;\n}\n\n.company-switch-no-icon {\n  box-shadow: 0 2px 4px 0 #a0a0a0;\n  font-size: 27px;\n  color: $fms-blue;\n  cursor: pointer;\n  width: 37px;\n  height: 37px;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 39px;\n}\n\n.company-name {\n  padding: 0 7px;\n  font-size: 10px;\n  color: $fms-gray;\n}\n\n\n.company-text {\n  font-family: NotoSans;\n  font-size: 14px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: $fms-blue;\n  padding-left: 8px;\n  padding-top: 20px;\n}\n\n.company-image {\n  padding-left: 5px;\n  padding-top: 11px;\n}\n\n.company-box {\n  display: flex;\n  height: 60px;\n  cursor: pointer;\n}\n\n.company-box:hover {\n  background: $fms-blue-light;\n}\n\n.wrapper {\n  overflow: visible;\n\n  .nav-bar {\n    ul {\n      list-style: none;\n      padding-left: 10px;\n      margin: 0;\n      position: relative;\n\n      li {\n        vertical-align: middle;\n        display: inline-block;\n        padding: 13px 20px;\n        border: 0px;\n        border-left-width: 3px;\n        border-style: solid;\n      }\n    }\n\n    .dropdown-container {\n      display: inline-block;\n      position: relative;\n\n      ::-webkit-scrollbar {\n        width: 5px;\n        height: 5px;\n      }\n\n      ::-webkit-scrollbar-track {\n        webkit-box-shadow: inset 0 0 6px $fms-gray-light;\n        -webkit-border-radius: 10px;\n        border-radius: 10px;\n        background: $fms-gray-light;\n      }\n\n      ::-webkit-scrollbar-thumb {\n        -webkit-border-radius: 10px;\n        border-radius: 10px;\n        background: $fms-blue;\n        -webkit-box-shadow: none;\n      }\n\n      ::-webkit-scrollbar-thumb:window-inactive {\n        background: $fms-blue;\n      }\n\n      .dropdown {\n        position: relative;\n        cursor: pointer;\n        z-index: 2;\n      }\n\n      .dropdown-menu {\n        position: absolute;\n        display: block;\n        z-index: 1;\n        border: 0;\n        border-radius: 0;\n        // left: -110px;\n        left: -6px;\n        top: 50px;\n        min-height: 10px;\n        min-width: 10px;\n        // width: 230px;\n        width: 270px;\n\n        .dropdown-body {\n          max-height: 80vh;\n          background: lighten($fms-gray-light, 2%);\n          overflow-y: auto;\n          overflow-x: auto;\n          box-shadow: 0 4px 4px 0 #bbb5b5;\n\n\n        }\n      }\n      .count {\n        position: absolute;\n        top: -6px;\n        right: -1px;\n        height: 15px;\n        width: 15px;\n        overflow: hidden;\n        background: $fms-green;\n        color: $fms-white;\n        text-align: center;\n        border-radius: 100%;\n        font-size: 9px;\n        font-weight: bold;\n        line-height: 15px;\n      }\n    }\n\n    .notifications {\n      // 2margin-right: 10px;\n    }\n\n    .messages {\n      margin-left: 10px\n    }\n\n    .user {\n      background: $fms-blue;\n      border-left: 0px;\n      position: absolute;\n      right: 0;\n      top: -1px;\n    }\n  }\n}\n\n::-webkit-scrollbar {\n  width: 3px;\n}\n\n::-webkit-scrollbar-track {\n  webkit-box-shadow: inset 0 0 6px $fms-gray-light;\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: $fms-gray-light;\n}\n\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: $fms-blue;\n  -webkit-box-shadow: none;\n}\n\n::-webkit-scrollbar-thumb:window-inactive {\n  background: $fms-blue;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
